import React from 'react';
import { Field, getFormValues, change } from 'redux-form';
import { connect } from 'react-redux';
import Select from 'react-select';

import { onClickCreateNewBrand } from 'actions/library/item';
import SettingField from 'components/Fields/ReduxForm/SettingField';
import Media from '../Media';
import DropdownCreateable from '../DropdownCreateable';
import styles from './ProductAttribute.css';

class RenderSelectField extends React.Component {
  onChangeSelect = newval => {
    const {
      input: { onChange },
      meta: { dispatch },
      itemForm: { weight, dimension },
    } = this.props;
    onChange(newval.value);
    if (newval.value === 'Kilogram (kg)') {
      const unitToDivide = weight.unit === 'Gram (gr)' ? 1000 : 1;
      const newWeight = {
        ...weight,
        value: weight.value / unitToDivide,
        valueUniversal: 1000,
      };
      dispatch(change('item', 'weight', newWeight));
      onChange(newval.value);
    }
    if (newval.value === 'Gram (gr)') {
      const unitToDivide = weight.unit === 'Gram (gr)' ? 1 : 1000;
      const newWeight = {
        ...weight,
        value: weight.value * unitToDivide,
        valueUniversal: 1,
      };
      dispatch(change('item', 'weight', newWeight));
      onChange(newval.value);
    }
    if (newval.value === 'Meter (m)') {
      const unitToConvert =
        dimension.unit === 'Centimeter (cm)'
          ? 100
          : dimension.unit === 'Inch (in)'
          ? 39.3701
          : 1;
      const newDimension = {
        ...dimension,
        length: (dimension.length / unitToConvert).toFixed(2),
        width: (dimension.width / unitToConvert).toFixed(2),
        height: (dimension.height / unitToConvert).toFixed(2),
        valueUniversal: 100,
      };
      dispatch(change('item', 'dimension', newDimension));
      onChange(newval.value);
    }
    if (newval.value === 'Centimeter (cm)') {
      const { length, width, height } = dimension;
      const newDimension = {
        ...dimension,
        length: this.converterUnitToCentimeter(length, dimension),
        width: this.converterUnitToCentimeter(width, dimension),
        height: this.converterUnitToCentimeter(height, dimension),
        valueUniversal: 1,
      };
      dispatch(change('item', 'dimension', newDimension));
      onChange(newval.value);
    }
    if (newval.value === 'Inch (in)') {
      const { length, width, height } = dimension;
      const newDimension = {
        ...dimension,
        length: this.convertUnitToInch(length, dimension),
        width: this.convertUnitToInch(width, dimension),
        height: this.convertUnitToInch(height, dimension),
        valueUniversal: 2.54,
      };
      dispatch(change('item', 'dimension', newDimension));
      onChange(newval.value);
    }
  };

  converterUnitToCentimeter = (field, dimension) => {
    return dimension.unit === 'Meter (m)'
      ? (field * 100).toFixed(2)
      : dimension.unit === 'Inch (in)'
      ? (field * 2.54).toFixed(2)
      : field.toFixed(2);
  };

  convertUnitToInch = (field, dimension) => {
    return dimension.unit === 'Meter (m)'
      ? (field * 39.3701).toFixed(2)
      : dimension.unit === 'Centimeter (cm)'
      ? (field / 2.54).toFixed(2)
      : field.toFixed(2);
  };

  render() {
    const {
      input: { value },
      placeholder,
      options,
      disabled,
      className,
    } = this.props;

    const selectProps = {
      value,
      className: className || '',
      placeholder,
      onChange: this.onChangeSelect,
      options,
      disabled,
      clearable: false,
      backspaceRemoves: false,
    };
    return <Select {...selectProps} />;
  }
}

const normalizeNumber = (value = 0, previousValue) => {
  if (value === '') {
    return value;
  }
  if (!isNaN(value)) {
    return value;
  }
  return previousValue;
};

const ProductAtrribute = props => {
  const { brands, onClickCreateNewBrand, itemForm, ecommerceCategory } = props;
  const optionsbrand = brands.map(brand => ({
    value: brand.id,
    label: brand.name,
  }));

  const optionsConditon = [
    { value: 'New', label: 'New' },
    { value: 'Refurbished', label: 'Refurbished' },
    { value: 'Used', label: 'Used' },
  ];

  const optionsAge = [
    { value: 'All Ages', label: 'All Ages' },
    { value: 'Adult', label: 'Adult' },
    { value: 'Teen', label: 'Teen' },
    { value: 'Kids', label: 'Kids' },
    { value: 'Toddler', label: 'Toddler' },
    { value: 'Infant', label: 'Infant' },
    { value: 'New Born', label: 'New Born' },
  ];

  const optionGender = [
    { value: 'Unisex', label: 'Unisex' },
    { value: 'Female', label: 'Female' },
    { value: 'Male', label: 'Male' },
  ];

  const optionUnit = [
    { value: 'Kilogram (kg)', label: 'Kilogram (kg)' },
    { value: 'Gram (gr)', label: 'Gram (gr)' },
  ];

  const optionDimension = [
    { value: 'Meter (m)', label: 'Meter (m)' },
    { value: 'Centimeter (cm)', label: 'Centimeter (cm)' },
    { value: 'Inch (in)', label: 'Inch (in)' },
  ];

  const isClothing = ecommerceCategory.google_category_id === 166;

  return (
    <div className="form-group mt-10px">
      <div className={`${styles['field-wrapper']} col-lg-3 col-md-4`}>
        <span className={styles['field-name']}> Brand Name </span>
      </div>
      <div className="col-lg-9 col-md-8">
        <div className={`form-group ${styles.categories}`}>
          <Field
            isErrorable
            component={DropdownCreateable}
            maxLength={50}
            name="brand_id"
            options={optionsbrand}
            list={brands}
            onCreate={onClickCreateNewBrand}
            placeholder="Select or Write brand name"
          />
        </div>
      </div>

      <div className={`${styles['field-wrapper']} col-lg-3 col-md-4`}>
        <span className={styles['field-name']}> Condition </span>
      </div>
      <div className="col-lg-9 col-md-8">
        <div className={`form-group ${styles.categories}`}>
          <Field
            component={RenderSelectField}
            name="condition"
            className={styles['field-weight-condition']}
            options={optionsConditon}
            placeholder="Select an option"
            itemForm={itemForm}
          />
        </div>
      </div>

      <div className={`${styles['field-wrapper']} col-lg-3 col-md-4`}>
        <span className={styles['field-name']}> Weight </span>
      </div>
      <div className="col-lg-2 col-md-2 no-padding-right">
        <div className="form-group">
          <Field
            component={SettingField}
            className="form-control"
            inputClassName={styles['field-weight-value']}
            autoComplete="off"
            name="weight.value"
            feedbackClassName={styles['feedback-error']}
            placeholder="0.0"
            normalize={normalizeNumber}
            positiveNumberOnly
          />
        </div>
      </div>
      <div className="col-lg-3 col-md-3 no-padding-left">
        <div className={`form-group ${styles.categories}`}>
          <Field
            component={RenderSelectField}
            name="weight.unit"
            options={optionUnit}
            itemForm={itemForm}
            className="select-dropdown-weight-unit"
            placeholder="Select an option"
          />
        </div>
      </div>
      <div className="col-lg-4 col-md-3 no-padding-left no-padding-right">
        <div className={`form-group ${styles['field-weight-info']}`}>
          <div>
            <svg
              width="17"
              height="16"
              viewBox="0 0 17 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.5875 2.93252L13.53 1.87502L12.1875 3.22502L13.245 4.28252L14.5875 2.93252ZM9 2.25002H7.5V2.38419e-05H9V2.25002ZM16.5 9.00002H14.25V7.50002H16.5V9.00002ZM7.5 14.2125V11.2425L6.75 10.8075C5.82 10.2675 5.25 9.27752 5.25 8.21252C5.25 6.55502 6.5925 5.21253 8.25 5.21253C9.9075 5.21253 11.25 6.55502 11.25 8.21252C11.25 9.27752 10.6725 10.2675 9.75 10.8075L9 11.2425V14.2125L7.5 14.2125ZM6 15.7125L10.5 15.7125V12.105C11.8425 11.325 12.75 9.87752 12.75 8.21252C12.75 5.73002 10.7325 3.71253 8.25 3.71253C5.7675 3.71253 3.75 5.73002 3.75 8.21252C3.75 9.87752 4.6575 11.325 6 12.105V15.7125ZM2.25 9.00002H0V7.50002H2.25L2.25 9.00002ZM4.32 3.21752L2.9775 1.86752L1.92 2.92502L3.27 4.26752L4.32 3.21752Z"
                fill="#8A8A8A"
              />
            </svg>
          </div>

          <p>
            Insert product weight including the packaging to calculate shipping
            rate.
          </p>
        </div>
      </div>

      <div className={`${styles['field-wrapper']} col-lg-3 col-md-4`}>
        <span className={styles['field-name']}> Dimension </span>
      </div>
      <div className="col-lg-9 col-md-8">
        <div className={styles['field-dimension-value']}>
          <Field
            component={SettingField}
            className="form-control"
            inputClassName={styles['field-weight-value']}
            name="dimension.length"
            placeholder="Length"
            normalize={normalizeNumber}
            feedbackClassName={styles['feedback-error']}
            positiveNumberOnly
            autoComplete="off"
          />
        </div>
        <div className={styles['field-dimension-value']}>
          <Field
            component={SettingField}
            className="form-control"
            inputClassName={styles['field-weight-value']}
            name="dimension.width"
            placeholder="Width"
            normalize={normalizeNumber}
            feedbackClassName={styles['feedback-error']}
            positiveNumberOnly
            autoComplete="off"
          />
        </div>
        <div className={styles['field-dimension-value']}>
          <Field
            component={SettingField}
            className="form-control"
            inputClassName={styles['field-weight-value']}
            name="dimension.height"
            placeholder="Height"
            normalize={normalizeNumber}
            feedbackClassName={styles['feedback-error']}
            positiveNumberOnly
            autoComplete="off"
          />
        </div>
        <div className={styles['field-dimension-unit']}>
          <Field
            component={RenderSelectField}
            name="dimension.unit"
            options={optionDimension}
            className="select-dropdown-weight-unit"
            placeholder="Select an option"
            itemForm={itemForm}
          />
        </div>
      </div>

      <div className="col-lg-9 col-md-9 col-lg-offset-3 col-md-offset-3 mt-10px no-padding-right">
        <div className={`form-group ${styles['field-dimension-info']}`}>
          <div>
            <svg width="17" height="16" viewBox="0 0 17 16" fill="none">
              <path
                d="M14.5875 2.93252L13.53 1.87502L12.1875 3.22502L13.245 4.28252L14.5875 2.93252ZM9 2.25002H7.5V2.38419e-05H9V2.25002ZM16.5 9.00002H14.25V7.50002H16.5V9.00002ZM7.5 14.2125V11.2425L6.75 10.8075C5.82 10.2675 5.25 9.27752 5.25 8.21252C5.25 6.55502 6.5925 5.21253 8.25 5.21253C9.9075 5.21253 11.25 6.55502 11.25 8.21252C11.25 9.27752 10.6725 10.2675 9.75 10.8075L9 11.2425V14.2125L7.5 14.2125ZM6 15.7125L10.5 15.7125V12.105C11.8425 11.325 12.75 9.87752 12.75 8.21252C12.75 5.73002 10.7325 3.71253 8.25 3.71253C5.7675 3.71253 3.75 5.73002 3.75 8.21252C3.75 9.87752 4.6575 11.325 6 12.105V15.7125ZM2.25 9.00002H0V7.50002H2.25L2.25 9.00002ZM4.32 3.21752L2.9775 1.86752L1.92 2.92502L3.27 4.26752L4.32 3.21752Z"
                fill="#8A8A8A"
              />
            </svg>
          </div>
          <p>
            Insert product dimension after packaging to calculate shipping rate.
          </p>
        </div>
      </div>

      {isClothing && (
        <div className={`${styles['field-wrapper']} col-lg-3 col-md-4`}>
          <span className={styles['field-name']}> Age Group </span>
        </div>
      )}
      {isClothing && (
        <div className="col-lg-9 col-md-8">
          <div className={`form-group ${styles.categories}`}>
            <Field
              component={RenderSelectField}
              name="age.value"
              options={optionsAge}
              placeholder="Select an option"
              itemForm={itemForm}
            />
          </div>
        </div>
      )}

      {isClothing && (
        <div className={`${styles['field-wrapper']} col-lg-3 col-md-4`}>
          <span className={styles['field-name']}> Gender </span>
        </div>
      )}

      {isClothing && (
        <div className="col-lg-9 col-md-8">
          <div className={`form-group ${styles.categories}`}>
            <Field
              component={RenderSelectField}
              name="gender.value"
              options={optionGender}
              placeholder="Select an option"
              itemForm={itemForm}
            />
          </div>
        </div>
      )}
      <div className={`col-lg-12 ${styles['online-image-wrapper']}`}>
        <div className="form-group">
          <label className={`${styles['field-name']}`}>
            Online Store Images
          </label>
        </div>
        <Media />
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  const { brands, ecommerceCategory } = state.library.item;
  return {
    brands,
    ecommerceCategory,
    itemForm: getFormValues('item')(state),
  };
};

const mapDispatchToProps = {
  onClickCreateNewBrand,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductAtrribute);
